import type { ValueOf } from 'cpool-utils';

export const CHAT_WINDOW_STATES = {
    EXPIRED: 'expired',
    NO_INBOUND_YET: 'no_inbound_yet',
    OPEN: 'open',
} as const;

export type ChatWindowState = ValueOf<typeof CHAT_WINDOW_STATES>;

export const CHAT_STATUS_LABELS = {
    ANSWERED: 'answered',
    AWAITING_CUSTOMER_REPLY: 'awaiting_customer_reply',
    NO_MESSAGES: 'no_messages',
    WINDOW_EXPIRED: 'window_expired',
    WINDOW_OPEN: 'window_open',
} as const;

export type ChatStatusLabel = ValueOf<typeof CHAT_STATUS_LABELS>;

export const CHAT_LIST_FILTERS = {
    ALL: 'all',
    NAME_AZ: 'name_az',
    UNLINKED: 'unlinked',
    UNREAD: 'unread',
    ...CHAT_STATUS_LABELS,
} as const;

export type ChatListFilterId = ValueOf<typeof CHAT_LIST_FILTERS>;
